<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="筛选学生">
                                <el-select v-model="$parentInfo.Dialog_SellInvoice.filter.student_id" placeholder="学生"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选合同ID">
                                <el-select v-model="$parentInfo.Dialog_SellInvoice.filter.invoice_id" placeholder="合同"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in invoices"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="orderLeaseInventory"
                        style="width: 100%"
                        size="middle"
                        :height="550"
                >
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table
                                    :data="props.row.invoiceShops"
                                    style="width: 100%"
                                    size="middle"
                            >
                                <el-table-column prop="shop_name" label="商品"></el-table-column>
                                <el-table-column prop="serial_id" label="序列号"></el-table-column>
                                <el-table-column prop="state" label="状态"></el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column prop="invoice_id" label="合同编号"></el-table-column>
                    <el-table-column prop="student_name" label="学生姓名"></el-table-column>
                    <el-table-column prop="borrow_status" label="状态"></el-table-column>
                    <el-table-column label="" width="65">
                        <template scope="scope">
                            <el-radio :label="scope.row.invoice_id" v-model="invoiceid" @change.native="handleSelectionChange(scope.$index,scope.row)">&nbsp</el-radio>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="$parentInfo.Dialog_SellInvoice.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.Dialog_SellInvoice.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button size="mini" @click="handleDelivery()">交货</el-button>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialog_SellInvoice",
        data() {
            return {
                invoiceid:'',
                templateSelection:'',
                students:[],
                invoices:[]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
            this.handelSearchByStudentName();
            this.handelSearchByInvoiceId();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderLeaseInventory: function () {
                return this._.orderBy(this.$parentInfo.Dialog_SellInvoice.leaseInvoices, 'invoice_id', 'asc');
            }
        },
        methods: {
            handleInfo(currentPage = 1){
                if (currentPage === 1) {
                    this.$parentInfo.Dialog_SellInvoice.currentPage = 1
                }
                this.$parentInfo.Dialog_SellInvoice.loading = true;
                this.$axios.get(store.state.server + '/getSellInvoiceList?'+
                    'studentId='+this.$parentInfo.Dialog_SellInvoice.filter.student_id +
                    '&invoiceId='+this.$parentInfo.Dialog_SellInvoice.filter.invoice_id +
                    '&page='+this.$parentInfo.Dialog_SellInvoice.currentPage +
                    '&limit=' + this.$parentInfo.Dialog_SellInvoice.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialog_SellInvoice.leaseInvoices=response.data.content.list
                        this.$parentInfo.Dialog_SellInvoice.total=response.data.content.total
                        this.$parentInfo.Dialog_SellInvoice.loading = false;
                    }
                })
            },
            handleInit(){

            },
            handleChange(){

            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_SellInvoice.currentPageSize = val;
                this.handleInfo(this.$parentInfo.Dialog_SellInvoice.currentPage, this.$parentInfo.Dialog_SellInvoice.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_SellInvoice.currentPage = val;
                this.handleInfo(this.$parentInfo.Dialog_SellInvoice.currentPage, this.$parentInfo.Dialog_SellInvoice.currentPageSize)
            },
            handleDelivery(){
                this.$Win.openModal('Dialog_SellDelivery', 700, 400, '交货',{'invoiceId':this.templateSelection.invoice_id});
            },
            handelSearchByStudentName(val=''){
                this.$axios.get(store.state.server + '/searchByStudentName?studentName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.students=response.data.content.students
                    }
                })
            },
            handelSearchByInvoiceId(val=''){
                this.$axios.get(store.state.server + '/searchByInvoiceId?invoiceId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.invoices=response.data.content.invoiceIds
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>